import { render, staticRenderFns } from "./LayoutFooter.vue?vue&type=template&id=782f21e5&"
import script from "./LayoutFooter.vue?vue&type=script&lang=js&"
export * from "./LayoutFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/code/nathan/Sonido_SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('782f21e5')) {
      api.createRecord('782f21e5', component.options)
    } else {
      api.reload('782f21e5', component.options)
    }
    module.hot.accept("./LayoutFooter.vue?vue&type=template&id=782f21e5&", function () {
      api.rerender('782f21e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/src/components/reviewer/LayoutFooter.vue"
export default component.exports